(function () {
  function setup() {
    var panel = document.querySelector('.mobile-facets__main');
    var src = document.querySelector('[data-cedar-csearch]');
    if (!panel || !src) return;
    if (!panel.querySelector('.cedar-csearch--panel')) {
      var c = src.cloneNode(true);
      c.removeAttribute('data-cedar-csearch');
      c.classList.add('cedar-csearch--panel');
      var inp = c.querySelector('input[type="search"]');
      var lab = c.querySelector('label');
      if (inp) inp.id = 'CedarColSearchPanel';
      if (lab) lab.setAttribute('for', 'CedarColSearchPanel');
      panel.insertBefore(c, panel.firstChild);
    }
    var open = document.querySelector('.mobile-facets__open');
    if (open && !open.getAttribute('data-relabeled')) {
      var walker = document.createTreeWalker(open, NodeFilter.SHOW_TEXT);
      var n;
      while ((n = walker.nextNode())) {
        if (/filter/i.test(n.nodeValue)) { n.nodeValue = n.nodeValue.replace(/filter\s*(and|&)?\s*sort|filter/i, 'Search & sort'); }
      }
      open.setAttribute('data-relabeled', '1');
    }
  }
  var timer;
  new MutationObserver(function () { clearTimeout(timer); timer = setTimeout(setup, 60); }).observe(document.documentElement, { childList: true, subtree: true });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', setup); else setup();
})();
